/* eslint-disable no-undefined */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
import { brand } from '../../theme/themePrimitives';
import CardWrapper from '../wrapper/card';
import CustomDropdown from '../reusable/dropdown';
import CustomInput from '../reusable/input';
import DeleteNotificationModal from './modal/delete_notification';
import { emailVariables } from '../../helper/lists';
import { green } from '@mui/material/colors';
import LabelWrapper from '../wrapper/label';
import { scheduleEmailConfirmationSchema } from '../../schema/calendar_schema';
import { settingCalendarSelectedNotification } from '../../redux/slices/calendar';
import { styled } from '@mui/material/styles';
import { toast } from 'react-toastify';
import { AccessTime, Delete, Edit, Email, ExpandMore, MoreVert } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Divider, IconButton, Menu, MenuItem, Switch, Typography } from '@mui/material';
import { AppDispatch, RootState } from '../../redux/store';
import { CalendarNotificaitonObject, CreateNotificationConfirmationParams, CreateNotificationScheduledParams } from '../../params/redux/calendar';
import { createCalendarLinkNotificationConfirmationThunk, createCalendarLinkNotificationSchedulingThunk, createMeetingNotificationConfirmationThunk, createMeetingNotificationSchedulingThunk } from '../../redux/thunks/calendar';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useRef, useState } from 'react';

const IOSSwitch = styled(Switch)(({ theme }) => ({
    'width': 42,
    'height': 26,
    'padding': 0,
    '& .MuiSwitch-switchBase': {
        'padding': 0,
        'margin': 2,
        'transitionDuration': '300ms',
        '&.Mui-checked': {
            'transform': 'translateX(16px)',
            'color': '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: green[300],
                opacity: 1,
                border: 0
            }
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.5
        }
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500
        })
    }
}));

const EmailNotificationComponent = ({ setSchedule }: { setSchedule: (value: 'email') => void }) => {
    const dispatch = useDispatch<AppDispatch>();
    const [showDelete, setShowDelete] = useState<number>(0);
    const [anchorEl, setAnchorEl] = useState<{
        anchorEl: null | HTMLElement,
        id: number
    }>();
    const [expanded, setExpanded] = useState<string | false>('confirmation');
    const handleMoreButton = (buttonEvent: React.MouseEvent<HTMLButtonElement>, notificationId: number) => {
        setAnchorEl({
            anchorEl: buttonEvent.currentTarget,
            id: notificationId
        });
    };
    const { selectedEvent, notificationDetails } = useSelector((state: RootState) => state.calendar);
    const existingConfirmation = notificationDetails.notifications.find((n) => n.notification_type === 'confirmation' && n.type === 'email');
    // const [enabled, setEnabled] = useState<boolean>(existingConfirmation?.status === 'enabled' || false);

    const handleExpand =
        (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false);
        };

    const handleSave = async (values: {
        subject: string;
        message: string;
    }) => {
        try {
            const data: CreateNotificationConfirmationParams = {
                calendar_id: selectedEvent?.type === 'link' ? selectedEvent?.id : undefined,
                event_id: selectedEvent?.type === 'meeting' ? selectedEvent?.id : undefined,
                subject: values.subject,
                message: values.message,
                type: 'email',
                notification_type: 'confirmation',
                status: existingConfirmation?.status === 'enabled' ? 'enabled' : 'disabled'
            };
            if (selectedEvent?.type === 'link') {
                await dispatch(createCalendarLinkNotificationConfirmationThunk(data)).unwrap();
            } else {
                await dispatch(createMeetingNotificationConfirmationThunk(data)).unwrap();
            }
            toast.success('Confirmation Email updated successfully', {
                theme: 'dark',
                position: 'top-left'
            });
        } catch (e) {
            //
        }
    };

    const enableDisableConfirmationHandler = async () => {
        try {
            const data: CreateNotificationConfirmationParams = {
                calendar_id: selectedEvent?.type === 'link' ? selectedEvent?.id : undefined,
                event_id: selectedEvent?.type === 'meeting' ? selectedEvent?.id : undefined,
                subject: existingConfirmation?.subject || '',
                message: existingConfirmation?.message || '',
                type: 'email',
                notification_type: 'confirmation',
                status: existingConfirmation?.status === 'enabled' ? 'disabled' : 'enabled'
            };
            if (selectedEvent?.type === 'link') {
                await dispatch(createCalendarLinkNotificationConfirmationThunk(data)).unwrap();
            } else {
                await dispatch(createMeetingNotificationConfirmationThunk(data)).unwrap();
            }
            toast.success('Confirmation Email updated successfully', {
                theme: 'dark',
                position: 'top-left'
            });
        } catch (e) {
            //
        }
    };

    const handleSchedule = () => {
        setSchedule('email');
    };


    const editNotificationHandler = (notificaiton: CalendarNotificaitonObject) => {
        dispatch(settingCalendarSelectedNotification(notificaiton));
        handleSchedule();
    };

    const deleteNotificationHandler = (notificaiton: CalendarNotificaitonObject) => {
        dispatch(settingCalendarSelectedNotification(notificaiton));
        setShowDelete(notificaiton.id);
    };

    const enableDisabledHandler = async (notification: CalendarNotificaitonObject) => {
        try {
            const data: CreateNotificationScheduledParams = {
                calendar_id: selectedEvent?.type === 'link' ? selectedEvent?.id : undefined,
                event_id: selectedEvent?.type === 'meeting' ? selectedEvent?.id : undefined,
                subject: notification.subject,
                message: notification.message,
                type: 'email',
                notification_type: 'scheduled',
                schedule_day: notification.schedule_day,
                schedule_hour: notification.schedule_hour,
                schedule_type: notification.schedule_type,
                schedule_min: notification.schedule_min,
                schedule_id: notification.id,
                status: notification.status === 'enabled' ? 'disabled' : 'enabled'
            };
            if (selectedEvent?.type === 'link') {
                await dispatch(createCalendarLinkNotificationSchedulingThunk(data)).unwrap();
            } else {
                await dispatch(createMeetingNotificationSchedulingThunk(data)).unwrap();
            }
        } catch (e) {
            //
        }
    };

    return (
        <Box pt={2}>
            {/* Confirmation Email */}
            {(selectedEvent?.type === 'link' &&
                !notificationDetails.notifications.some((n) => n.notification_type === 'confirmation' && n.type === 'email' && selectedEvent?.type !== 'link')) && (<Accordion expanded={expanded === 'confirmation'} onChange={handleExpand('confirmation')}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Box>
                            <Typography variant="subtitle1" gutterBottom>Confirmation Email</Typography>
                            <Box display="flex" gap={2} mt={2} alignItems="center">
                                <Typography variant="body1" fontWeight="bold" sx={{ color: existingConfirmation?.status === 'enabled' ? brand[300] : 'text.secondary' }}>{existingConfirmation?.status === 'enabled' ? 'Enabled' : 'Disabled'}</Typography>
                                <Box
                                    onClick={(e) => e.stopPropagation()}
                                    onFocus={(e) => e.stopPropagation()}
                                >
                                    <IOSSwitch
                                        checked={existingConfirmation?.status === 'enabled'}
                                        onChange={() => enableDisableConfirmationHandler()}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Formik
                            enableReinitialize
                            initialValues={{
                                subject: existingConfirmation?.subject || '',
                                message: existingConfirmation?.message || ''
                            }}
                            validationSchema={scheduleEmailConfirmationSchema}
                            onSubmit={handleSave}
                        >
                            {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => {
                                const messageInputRef = useRef<HTMLTextAreaElement>(null);
                                const subjectInputRef = useRef<HTMLInputElement>(null);
                                const handleAddField = (field: string) => {
                                    const textarea = subjectInputRef.current;
                                    if (!textarea) {
                                        // fallback to appending
                                        setFieldValue('subject', `${values.subject} [${field}] `);
                                        return;
                                    }
                                    const start = textarea.selectionStart || 0;
                                    const end = textarea.selectionEnd || 0;
                                    const insertText = `[${field}]`;
                                    const newMessage =
                                        values.subject.slice(0, start) +
                                        insertText +
                                        values.subject.slice(end);
                                    setFieldValue('subject', newMessage);
                                    // Restore focus and cursor after insertion
                                    setTimeout(() => {
                                        textarea.focus();
                                        const cursorPos = start + insertText.length;
                                        textarea.setSelectionRange(cursorPos, cursorPos);
                                    }, 0);
                                };
                                const handleAddMessageField = (field: string) => {
                                    const textarea = messageInputRef.current;
                                    if (!textarea) {
                                        // fallback to appending
                                        setFieldValue('message', `${values.message} [${field}] `);
                                        return;
                                    }
                                    const start = textarea.selectionStart || 0;
                                    const end = textarea.selectionEnd || 0;
                                    const insertText = `[${field}]`;
                                    const newMessage =
                                        values.message.slice(0, start) +
                                        insertText +
                                        values.message.slice(end);
                                    setFieldValue('message', newMessage);
                                    // Restore focus and cursor after insertion
                                    setTimeout(() => {
                                        textarea.focus();
                                        const cursorPos = start + insertText.length;
                                        textarea.setSelectionRange(cursorPos, cursorPos);
                                    }, 0);
                                };
                                return <Form>
                                    <Box display="flex" flexDirection="column" gap={2}>
                                        <Box display="flex" justifyContent="space-between" alignItems="center">
                                            <LabelWrapper label="Subject" sx={{ mb: 0 }} />
                                            <Box>
                                                <CustomDropdown
                                                    sx={{ mb: 0 }}
                                                    value={''}
                                                    // onChange={(e) => setFieldValue('subject', `${values.subject} [${e.target.value}]`)}
                                                    onChange={(e) => handleAddField(e.target.value as string)}
                                                    options={emailVariables.map((item) => ({ label: item, value: item }))}
                                                />
                                            </Box>
                                        </Box>
                                        <CustomInput
                                            fullWidth
                                            type="text"
                                            value={values.subject}
                                            onChange={handleChange('subject')}
                                            onBlur={handleBlur('subject')}
                                            error={touched.subject && Boolean(errors.subject)}
                                            placeholder="e.g. Confirmed: [Event Name] with [Organizer Name]"
                                            inputRef={subjectInputRef}
                                        />
                                        <Box display="flex" justifyContent="space-between" alignItems="center">
                                            <LabelWrapper label="Message" sx={{ mb: 0 }} />
                                            <Box>
                                                <CustomDropdown
                                                    sx={{ mb: 0 }}
                                                    value={''}
                                                    // onChange={(e) => setFieldValue('subject', `${values.subject} [${e.target.value}]`)}
                                                    onChange={(e) => handleAddMessageField(e.target.value as string)}
                                                    options={emailVariables.map((item) => ({ label: item, value: item }))}
                                                />
                                            </Box>
                                        </Box>
                                        <CustomInput
                                            fullWidth
                                            type="textarea"
                                            rows={4}
                                            value={values.message}
                                            onChange={handleChange('message')}
                                            onBlur={handleBlur('message')}
                                            error={touched.message && Boolean(errors.message)}
                                            placeholder="Enter your message here"
                                            inputRef={messageInputRef}
                                        />
                                        <Box mt={2} display="flex" justifyContent="flex-end">
                                            <Button variant="contained" type="submit">
                                                Save
                                            </Button>
                                        </Box>
                                    </Box>
                                </Form>;
                            }}
                        </Formik>
                    </AccordionDetails>
                </Accordion>)}

            {/* Email Scheduling */}
            <Accordion expanded={expanded === 'scheduling'} onChange={handleExpand('scheduling')}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Box>
                        <Typography variant="subtitle1" gutterBottom>Email Scheduling</Typography>
                        <Typography variant="body2" mb={2}>
                            (Schedule email notifications to be sent before or after the event)
                        </Typography>
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    {/* You can extend this with a date/time scheduler component */}
                    <Box mt={2} display="flex" justifyContent="space-between">
                        <Typography variant="subtitle1" color="textSecondary">Scheduled Emails</Typography>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<Email />}
                            onClick={handleSchedule}
                            sx={{ display: selectedEvent?.type === 'meeting' ? 'none' : 'block' }}
                        >
                            Scheduled Email
                        </Button>
                    </Box>
                    <Box display="flex" gap={2} pt={2} flexWrap="wrap">
                        {notificationDetails.notifications.filter((notification) => notification.type === 'email' && notification.notification_type !== 'confirmation').map((notification) => (
                            <CardWrapper
                                key={notification.id}
                                sx={{
                                    width: 'calc(50% - 8px)'
                                }}
                            >
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography variant="subtitle1" fontWeight="bold">
                                        {notification.subject || 'Untitled Notification'}
                                    </Typography>
                                    <IconButton onClick={(e) => handleMoreButton(e, notification.id)} size="small">
                                        <MoreVert />
                                    </IconButton>
                                    <Menu
                                        anchorEl={anchorEl?.anchorEl && notification.id === anchorEl.id ? anchorEl.anchorEl : null}
                                        open={anchorEl?.anchorEl !== null && notification.id === anchorEl?.id}
                                        onClose={() => setAnchorEl({
                                            anchorEl: null,
                                            id: 0
                                        })}
                                        MenuListProps={{
                                            'aria-labelledby': 'add-pipeline-button'
                                        }}
                                    >
                                        <MenuItem onClick={() => editNotificationHandler(notification)}>
                                            <Box display="flex" alignItems="center" gap={2}><Edit color="disabled" />
                                                <Typography color="textSecondary" variant="body2">
                                                    Edit
                                                </Typography>
                                            </Box>
                                        </MenuItem>
                                        <MenuItem onClick={() => deleteNotificationHandler(notification)}>
                                            <Box display="flex" alignItems="center" gap={2}><Delete color="disabled" /> <Typography color="textSecondary" variant="body2">Delete</Typography></Box>
                                        </MenuItem>
                                    </Menu>
                                </Box>
                                <Box display="flex" justifyContent="space-between" alignItems="center" my={1}>

                                    <Box display="flex" alignItems="center" gap={1} color="text.secondary">
                                        <AccessTime fontSize="small" />
                                        <Typography variant="body2" color="text.secondary">
                                            {notification.schedule_day} days {notification.schedule_hour} hours {notification.schedule_min} minutes
                                            {' '} {notification.schedule_type} event
                                        </Typography>
                                    </Box>
                                    <Box display="flex" gap="10px" alignItems="center" my={1}>
                                        <Box px={2} borderRadius={1} py="0.1rem" bgcolor={brand[50]} color={brand[300]} height="max-content"><Typography variant="body1" fontWeight="bold">Reminder Email</Typography></Box>
                                    </Box>
                                </Box>
                                <Divider />

                                <Box mt={1}><IOSSwitch
                                    checked={notification.status === 'enabled'}
                                    onChange={() => enableDisabledHandler(notification)}
                                /></Box>
                                <DeleteNotificationModal open={showDelete === notification.id} onClose={() => setShowDelete(0)} />
                            </CardWrapper>
                        ))}
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Box>
    );
};

export default EmailNotificationComponent;